import './mcpServers.scss';
import "/gh_elements/trigger/gh_trigger_switch.scss";

import './mcpServers.service.js';

import { GUDHUB_SETTINGS } from '../../config.js';

angular.module('mcpServersTableModule')

    .directive('mcpServersTable', ['GhDialog', 'McpServersService', function (GhDialog, McpServersService) {
        return {
            restrict: 'E',
            scope: {
                mcpServers: '='
            },

            controller: ['$scope', 'localizationService', function ($scope, localizationService) {
                const dictionary = localizationService.getDictionary('account_settings');
                $scope.translate = (word) => localizationService.translate(word, dictionary);

                if (!Array.isArray($scope.mcpServers)) {
                    $scope.mcpServers = [];
                }

                $scope.$watchCollection('mcpServers', function (newValue) {
                    if (!Array.isArray(newValue)) {
                        $scope.mcpServers = [];
                    }
                });

                $scope.getStatusLabel = function (active) {
                    return McpServersService.getStatusLabel(active);
                };

                $scope.getStatusClass = function (active) {
                    return McpServersService.getStatusClass(active);
                };

                $scope.showDeleteMcpServerPopup = function (mcpServer) {
                    const tableScope = $scope;

                    GhDialog.show({
                        position: 'center',
                        toolbar: false,
                        template: {
                            toolbar: '',
                            resizable: false,
                            content: `
                                <div class="delete_mcp_server-popup">
                                    <div class="dialog-share-group">
                                        <span gh-icon="rubbish FF0D0D 65px"></span>
                                        <p class="dialog-share-group__title">Deleting MCP Server!</p>
                                    </div>

                                    <div class="dialog-share-group__content">
                                        <p class="info">
                                            Do you really want to delete this MCP server?
                                            You will not be able to restore it.
                                        </p>

                                        <div class="dialog-share-group__content__buttons">
                                            <button
                                                class="dialog-share-group__content__buttons__add btn btn-blue-reverse"
                                                ng-click="deleteMcpServer()"
                                            >
                                                Delete
                                            </button>

                                            <button
                                                class="dialog-share-group__content__buttons__cancel btn btn-blue"
                                                ng-click="cancel()"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            `
                        },
                        locals: {
                            mcpServer
                        },
                        controller: [
                            '$scope',
                            'mcpServer',
                            'McpServersService',
                            function ($scope, mcpServer, McpServersService) {
                                $scope.deleteMcpServer = async function () {
                                    try {
                                        await McpServersService.delete(mcpServer);

                                        if (!Array.isArray(tableScope.mcpServers)) {
                                            tableScope.mcpServers = [];
                                        }

                                        const index = tableScope.mcpServers.findIndex(function (server) {
                                            return server.mcp_server_name === mcpServer.mcp_server_name;
                                        });

                                        if (index !== -1) {
                                            tableScope.mcpServers.splice(index, 1);
                                        }

                                        tableScope.$applyAsync();
                                        $scope.cancel();
                                    } catch (error) {
                                        console.log('MCP server delete error:', error);
                                    }
                                };
                            }
                        ]
                    });
                };

                $scope.openMcpServer = function (e, mcpServer) {
                    const tableScope = $scope;

                    GhDialog.show({
                        position: 'full',
                        toolbar: false,
                        template: {
                            toolbar: '',
                            content: `
                                <div class="mcp-server-popup">
                                    <div class="mcp-server-popup__header">
                                        <div class="mcp-server-name-wrapper">
                                            <input
                                                type="text"
                                                ng-model="mcpServer.mcp_server_name"
                                                ng-style="{ width: getTitleWidth() }"
                                                class="mcp_server_name_input"
                                                readonly
                                            >
                                        </div>

                                        <span
                                            class="close_dialog"
                                            ng-click="cancel()"
                                            gh-icon="cross #0D99FF 30px"
                                        ></span>
                                    </div>

                                    <div class="mcp-server-popup__content">
                                        <div class="mcp-server-info">
                                            <p class="mcp-server-info__title">{{translate('MCP Server Info')}}</p>

                                            <div class="mcp-server-info__row">
                                                <p class="label">URL:</p>

                                                <div class="mcp-server-field">
                                                    <input
                                                        type="text"
                                                        class="mcp-server-field__input"
                                                        ng-value="getMcpServerEndpoint()"
                                                        readonly
                                                    >

                                                  <div class="field-actions">
                                                      <button
                                                          type="button"
                                                          class="copy_url_btn"
                                                          ng-class="{ 'copy_url_btn--copied': copiedUrl }"
                                                          ng-click="copyMcpServerUrl($event)"
                                                          title="{{translate(copiedUrl ? 'Copied' : 'Copy URL')}}"
                                                      >
                                                          {{translate(copiedUrl ? 'Copied!' : 'Copy')}}
                                                      </button>
                                                  </div>
                                                </div>
                                            </div>

                                            <div class="mcp-server-info__row editable-row">
                                                <p class="label">{{translate('Name:')}}</p>

                                                <div class="mcp-server-field">
                                                    <input
                                                        type="text"
                                                        class="mcp-server-field__input"
                                                        ng-model="mcpServer.mcp_server_name"
                                                        ng-readonly="!editMode.mcp_server_name"
                                                    >

                                                    <div class="field-actions" ng-if="!editMode.mcp_server_name">
                                                        <span
                                                            class="edit_icon"
                                                            gh-icon="pencil 0D99FF 22px normal"
                                                            ng-click="enableEdit('mcp_server_name')"
                                                        ></span>
                                                    </div>

                                                    <div class="field-actions" ng-if="editMode.mcp_server_name">
                                                        <span
                                                            class="save_icon"
                                                            gh-icon="checked 05B52C 22px normal"
                                                            ng-click="saveField('mcp_server_name')"
                                                        ></span>

                                                        <span
                                                            class="cancel_icon"
                                                            gh-icon="cross FF0000 22px normal"
                                                            ng-click="cancelEdit('mcp_server_name')"
                                                        ></span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="mcp-server-info__row editable-row">
                                                <p class="label">{{translate('Application:')}}</p>

                                                <div class="mcp-server-field">
                                                    <div class="mcp-server-field__select-wrapper">
                                                        <gh-input
                                                            gh-dropdown
                                                            autocomplete="appsList"
                                                            ng-model="mcpServer.app_with_functions"
                                                            gh-data-type="text_opt"
                                                            size="large">
                                                        </gh-input>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="mcp-server-info__row editable-row">
                                                <p class="label">{{translate('Field:')}}</p>

                                                <div class="mcp-server-field">
                                                    <div class="mcp-server-field__select-wrapper">
                                                        <gh-input
                                                            ng-if="mcpServer.app_with_functions"
                                                            gh-dropdown="fieldOptions"
                                                            ng-model="mcpServer.field_id_with_functions"
                                                            gh-data-type="text_opt"
                                                            show-loader="loadingFields"
                                                            gh-editable="true"
                                                            size="large">
                                                        </gh-input>

                                                        <gh-input
                                                            ng-if="!mcpServer.app_with_functions"
                                                            gh-dropdown="fieldOptions"
                                                            ng-model="mcpServer.field_id_with_functions"
                                                            gh-data-type="text_opt"
                                                            show-loader="loadingFields"
                                                            gh-editable="false"
                                                            size="large">
                                                        </gh-input>

                                                        <div
                                                            ng-show="mcpServer.app_with_functions && !loadingFields && !fieldsList.length"
                                                            class="mcp-no-items"
                                                        >
                                                            {{translate('No fields found in selected application')}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="mcp-server-info__row">
                                                <p class="label">{{translate('Active:')}}</p>

                                                <div class="active-toggle">
                                                    <label class="mcp-switch">
                                                        <input
                                                            type="checkbox"
                                                            ng-model="activeSwitch"
                                                            ng-change="toggleActive()"
                                                        >
                                                        <span class="mcp-switch__slider"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <mcp-external-functions-table mcp-server="mcpServer"></mcp-external-functions-table>
                                </div>
                            `
                        },
                        locals: {
                            mcpServer
                        },
                        controller: ['$scope', 'mcpServer', 'McpServersService', 'localizationService', function ($scope, mcpServer, McpServersService, localizationService) {
                            const dictionary = localizationService.getDictionary('account_settings');
                            $scope.translate = (word) => localizationService.translate(word, dictionary);
                            $scope.mcpServer = mcpServer;

                            $scope.editMode = {
                                mcp_server_name: false
                            };

                            $scope.originalValues = {
                                mcp_server_name: mcpServer.mcp_server_name || ''
                            };

                            $scope.fieldsList = [];
                            $scope.fieldOptions = [];
                            $scope.loadingFields = false;
                            $scope.activeSwitch = !!$scope.mcpServer.active;

                            const normalizeId = function (value) {
                                return String(value || '');
                            };

                            const safeApply = function () {
                                $scope.$applyAsync();
                            };

                            const clearExternalFunctions = function () {
                                $scope.mcpServer.items_with_functions = [];
                            };

                            const updateMcpServerEndpoint = function () {
                                $scope.mcpServer.mcp_server_endpoint = McpServersService.getMcpServerEndpoint($scope.mcpServer);
                            };

                            // McpServersService sends unset app/field ids as null (see
                            // prepareMcpServerData), and the server echoes that null back.
                            // Merging it in raw would flip these fields from the '' the
                            // app/field $watches normalize to, re-triggering them and
                            // looping this same save forever.
                            const applyUpdatedMcpServer = function (updatedMcpServer) {
                                Object.assign($scope.mcpServer, updatedMcpServer, {
                                    app_with_functions: normalizeId(updatedMcpServer.app_with_functions),
                                    field_id_with_functions: normalizeId(updatedMcpServer.field_id_with_functions)
                                });
                            };

                            const persistMcpServer = async function () {
                                try {
                                    updateMcpServerEndpoint();

                                    const updatedMcpServer = await McpServersService.update($scope.mcpServer);

                                    applyUpdatedMcpServer(updatedMcpServer);

                                    safeApply();
                                    tableScope.$applyAsync();
                                } catch (error) {
                                    console.log('MCP server settings update error:', error);
                                }
                            };

                            $scope.getTitleWidth = function () {
                                return McpServersService.getTitleWidth($scope.mcpServer.mcp_server_name);
                            };

                            $scope.getMcpServerEndpoint = function () {
                                return McpServersService.getMcpServerEndpoint($scope.mcpServer);
                            };

                            $scope.copiedUrl = false;

                            $scope.copyMcpServerUrl = async function ($event) {
                                if ($event) {
                                    $event.stopPropagation();
                                }

                                const url = $scope.getMcpServerEndpoint();

                                try {
                                    if (navigator.clipboard && navigator.clipboard.writeText) {
                                        await navigator.clipboard.writeText(url);
                                    } else {
                                        const textarea = document.createElement('textarea');

                                        textarea.value = url;
                                        textarea.setAttribute('readonly', '');
                                        textarea.style.position = 'absolute';
                                        textarea.style.left = '-9999px';

                                        document.body.appendChild(textarea);
                                        textarea.select();
                                        document.execCommand('copy');
                                        document.body.removeChild(textarea);
                                    }

                                    $scope.copiedUrl = true;
                                    $scope.$applyAsync();

                                    setTimeout(function () {
                                        $scope.copiedUrl = false;
                                        $scope.$applyAsync();
                                    }, 1500);
                                } catch (error) {
                                    console.log('MCP server URL copy error:', error);
                                }
                            };

                            $scope.getFieldLabel = function (field) {
                                return field.name || field.field_name || field.title || field.field_id;
                            };

                            $scope.loadFieldsBySelectedApplication = async function (resetField) {
                                // Every field_id_with_functions assignment in this function is
                                // programmatic (list reload, stale-selection cleanup, explicit
                                // reset), never a user picking a value in the gh-input dropdown —
                                // this flag stops the field $watch below from mistaking any of
                                // them for a real selection change and firing onFieldChange().
                                $scope._resettingFieldForAppChange = true;

                                try {
                                    $scope.fieldsList = [];
                                    $scope.fieldOptions = [];

                                    if (resetField) {
                                        $scope.mcpServer.field_id_with_functions = '';
                                    }

                                    if (!$scope.mcpServer.app_with_functions) {
                                        safeApply();
                                        return;
                                    }

                                    $scope.loadingFields = true;
                                    safeApply();

                                    try {
                                        const app = await gudhub.getApp($scope.mcpServer.app_with_functions);
                                        const fieldList = Array.isArray(app.field_list) ? app.field_list : [];

                                        $scope.fieldsList = fieldList.map(function (field) {
                                            return {
                                                ...field,
                                                field_id: normalizeId(field.field_id)
                                            };
                                        });

                                        // Reshaped into {name, value} pairs for the gh-input dropdown
                                        // (gh-dropdown="fieldOptions") — same list as fieldsList above,
                                        // labeled via getFieldLabel same as the old <select> options were.
                                        $scope.fieldOptions = $scope.fieldsList.map(function (field) {
                                            return { name: $scope.getFieldLabel(field), value: field.field_id };
                                        });

                                        const selectedFieldExists = $scope.fieldsList.some(function (field) {
                                            return normalizeId(field.field_id) === normalizeId($scope.mcpServer.field_id_with_functions);
                                        });

                                        if ($scope.mcpServer.field_id_with_functions && !selectedFieldExists) {
                                            $scope.mcpServer.field_id_with_functions = '';
                                        }
                                    } catch (error) {
                                        console.log('MCP fields load error:', error);
                                        $scope.fieldsList = [];
                                        $scope.fieldOptions = [];
                                        $scope.mcpServer.field_id_with_functions = '';
                                    } finally {
                                        $scope.loadingFields = false;
                                        safeApply();
                                    }
                                } finally {
                                    $scope._resettingFieldForAppChange = false;
                                    safeApply();
                                }
                            };

                            $scope.onApplicationChange = async function () {
                                $scope.mcpServer.app_with_functions = normalizeId($scope.mcpServer.app_with_functions);

                                clearExternalFunctions();

                                await $scope.loadFieldsBySelectedApplication(true);
                                await persistMcpServer();
                            };

                            $scope.onFieldChange = async function () {
                                $scope.mcpServer.field_id_with_functions = normalizeId($scope.mcpServer.field_id_with_functions);

                                clearExternalFunctions();

                                await persistMcpServer();
                            };

                            // gh-input has no ng-change-equivalent attribute, so reacting to a
                            // dropdown selection change moves to $watch instead of the old
                            // ng-change="onApplicationChange()"/"onFieldChange()" on the native
                            // <select> elements. Guarded against the immediate first invocation
                            // every $watch fires on registration (newVal === oldVal then).
                            $scope.$watch('mcpServer.app_with_functions', function (newVal, oldVal) {
                                if (newVal === oldVal) {
                                    return;
                                }

                                $scope.onApplicationChange();
                            });

                            $scope.$watch('mcpServer.field_id_with_functions', function (newVal, oldVal) {
                                if (newVal === oldVal || $scope._resettingFieldForAppChange) {
                                    return;
                                }

                                $scope.onFieldChange();
                            });

                            $scope.enableEdit = function (field) {
                                $scope.originalValues[field] = $scope.mcpServer[field] || '';
                                $scope.editMode[field] = true;

                                setTimeout(function () {
                                    if (field === 'mcp_server_name') {
                                        const titleInput = document.querySelector('.mcp_server_name_input');

                                        if (titleInput) {
                                            titleInput.removeAttribute('readonly');
                                            titleInput.focus();
                                        }
                                    }

                                    $scope.$applyAsync();
                                });
                            };

                            $scope.cancelEdit = function (field) {
                                $scope.mcpServer[field] = $scope.originalValues[field];
                                $scope.editMode[field] = false;

                                if (field === 'mcp_server_name') {
                                    const titleInput = document.querySelector('.mcp_server_name_input');

                                    if (titleInput) {
                                        titleInput.setAttribute('readonly', true);
                                    }
                                }

                                updateMcpServerEndpoint();

                                $scope.$applyAsync();
                                tableScope.$applyAsync();
                            };

                            $scope.saveField = async function (field) {
                                if (
                                    field === 'mcp_server_name' &&
                                    (!$scope.mcpServer.mcp_server_name || !$scope.mcpServer.mcp_server_name.trim().length)
                                ) {
                                    return false;
                                }

                                try {
                                    if (typeof $scope.mcpServer[field] === 'string') {
                                        $scope.mcpServer[field] = $scope.mcpServer[field].trim();
                                    }

                                    updateMcpServerEndpoint();

                                    const updatedMcpServer = await McpServersService.update($scope.mcpServer);

                                    applyUpdatedMcpServer(updatedMcpServer);

                                    $scope.originalValues[field] = $scope.mcpServer[field];
                                    $scope.editMode[field] = false;

                                    if (field === 'mcp_server_name') {
                                        const titleInput = document.querySelector('.mcp_server_name_input');

                                        if (titleInput) {
                                            titleInput.setAttribute('readonly', true);
                                        }
                                    }

                                    $scope.$applyAsync();
                                    tableScope.$applyAsync();
                                } catch (error) {
                                    console.log('MCP server update error:', error);
                                }
                            };

                            $scope.toggleActive = async function () {
                                const previousActive = $scope.mcpServer.active;

                                try {
                                    $scope.mcpServer.active = $scope.activeSwitch;

                                    await persistMcpServer();
                                } catch (error) {
                                    console.log('MCP server active update error:', error);

                                    $scope.mcpServer.active = previousActive;
                                    $scope.activeSwitch = previousActive;

                                    $scope.$applyAsync();
                                    tableScope.$applyAsync();
                                }
                            };

                            updateMcpServerEndpoint();

                            if ($scope.mcpServer.app_with_functions) {
                                $scope.mcpServer.app_with_functions = normalizeId($scope.mcpServer.app_with_functions);
                                $scope.loadFieldsBySelectedApplication(false);
                            }
                        }]
                    });
                };
            }],

            template: `
                <div class="listing_table">
                    <div class="listing_table_head_wrapper">
                        <div class="listing_table_column bottom_line w-50">
                            <div class="tab">{{translate('Name')}}</div>
                        </div>

                        <div class="listing_table_column w-35">
                            <div class="tab">{{translate('Active')}}</div>
                        </div>

                        <div class="listing_table_column w-15"></div>
                    </div>

                    <div class="listing_table_body_wrapper">
                        <div
                            class="listing_table_row"
                            ng-click="openMcpServer($event, mcpServer)"
                            ng-repeat="mcpServer in mcpServers track by mcpServer.mcp_server_name"
                        >
                            <div class="listing_table_column w-50">
                                <span class="number">{{$index + 1}}</span>
                                <div class="name">{{mcpServer.mcp_server_name}}</div>
                            </div>

                            <div class="listing_table_column w-35">
                                <span
                                    class="status-badge"
                                    ng-class="getStatusClass(mcpServer.active)"
                                >
                                    {{getStatusLabel(mcpServer.active)}}
                                </span>
                            </div>

                            <div class="listing_table_column w-15">
                                <span
                                    ng-click="showDeleteMcpServerPopup(mcpServer); $event.stopPropagation()"
                                    class="delete_icon"
                                    gh-icon="rubbish 0d99ff 20px"
                                ></span>
                            </div>
                        </div>

                        <div ng-if="!mcpServers.length" class="listing_table_nodata">
                            <p>{{translate('No MCP Servers')}}</p>
                        </div>
                    </div>
                </div>
            `
        };
    }])

    .directive('mcpExternalFunctionsTable', ['GhDialog', 'McpServersService', function (GhDialog, McpServersService) {
        return {
            restrict: 'E',
            scope: {
                mcpServer: '='
            },

            controller: ['$scope', 'localizationService', async function ($scope, localizationService) {
                const dictionary = localizationService.getDictionary('account_settings');
                $scope.translate = (word) => localizationService.translate(word, dictionary);

                $scope.itemRows = [];
                $scope.loading = true;

                const safeApply = function (scope) {
                    if (scope && scope.$root && !scope.$$phase && !scope.$root.$$phase) {
                        scope.$applyAsync();
                    }
                };

                const normalizeId = function (value) {
                    return String(value || '');
                };

                const getNodeServicesApiPath = function () {
                    if (
                        typeof GUDHUB_SETTINGS !== 'undefined' &&
                        GUDHUB_SETTINGS &&
                        GUDHUB_SETTINGS.node_services_api_path
                    ) {
                        return String(GUDHUB_SETTINGS.node_services_api_path).replace(/\/$/, '');
                    }

                    if (
                        window.GUDHUB_SETTINGS &&
                        window.GUDHUB_SETTINGS.node_services_api_path
                    ) {
                        return String(window.GUDHUB_SETTINGS.node_services_api_path).replace(/\/$/, '');
                    }

                    if (
                        window.gudhub_settings &&
                        window.gudhub_settings.node_services_api_path
                    ) {
                        return String(window.gudhub_settings.node_services_api_path).replace(/\/$/, '');
                    }

                    if (
                        gudhub &&
                        gudhub.settings &&
                        gudhub.settings.node_services_api_path
                    ) {
                        return String(gudhub.settings.node_services_api_path).replace(/\/$/, '');
                    }

                    return '';
                };

                const getAuthData = async function () {
                    const token = typeof gudhub.getToken === 'function'
                        ? await gudhub.getToken()
                        : '';

                    const user = gudhub.storage && typeof gudhub.storage.getUser === 'function'
                        ? gudhub.storage.getUser()
                        : {};

                    return {
                        token,
                        user_id: user.user_id,
                        auth_key: user.auth_key
                    };
                };

                const getSavedItems = function () {
                    if (!Array.isArray($scope.mcpServer.items_with_functions)) {
                        return [];
                    }

                    return $scope.mcpServer.items_with_functions.map(function (item) {
                        if (item && typeof item === 'object') {
                            return {
                                app_id: item.app_id || $scope.mcpServer.app_with_functions,
                                item_id: item.item_id,
                                active: typeof item.active === 'boolean' ? item.active : true
                            };
                        }

                        return {
                            app_id: $scope.mcpServer.app_with_functions,
                            item_id: item,
                            active: true
                        };
                    });
                };

                const getItemField = function (item, fieldId) {
                    const fields = Array.isArray(item.fields) ? item.fields : [];

                    return fields.find(function (field) {
                        return normalizeId(field.field_id) === normalizeId(fieldId);
                    });
                };

                const hasItemField = function (item, fieldId) {
                    return !!getItemField(item, fieldId);
                };

                const getRawItemFieldValue = function (item, fieldId) {
                    const itemField = getItemField(item, fieldId);

                    if (!itemField) {
                        return '';
                    }

                    return itemField.field_value || itemField.value || '';
                };

                const getAppField = function (app, fieldId) {
                    const fieldList = Array.isArray(app.field_list) ? app.field_list : [];

                    return fieldList.find(function (field) {
                        return normalizeId(field.field_id) === normalizeId(fieldId);
                    }) || null;
                };

                const getAppData = async function (appId) {
                    try {
                        const app = await gudhub.getApp(appId);

                        if (app && app.app_id) {
                            return app;
                        }

                        return await gudhub.getAppInfo(appId);
                    } catch (error) {
                        console.log('MCP get app error:', appId, error);
                        return await gudhub.getAppInfo(appId);
                    }
                };

                const getItemsByFieldId = async function (appId, fieldId) {
                    const items = await gudhub.getItems(appId);

                    if (!Array.isArray(items)) {
                        return [];
                    }

                    return items.filter(function (item) {
                        return hasItemField(item, fieldId);
                    });
                };

                const getItemLabel = async function (app, fieldId, item) {
                    const field = getAppField(app, fieldId);
                    const value = getRawItemFieldValue(item, fieldId);

                    if (!field || !field.data_type) {
                        return value || item.item_id;
                    }

                    try {
                        const interpretation = await gudhub.getInterpretation(
                            value,
                            field,
                            field.data_type,
                            'value',
                            item.item_id,
                            app.app_id
                        );

                        if (interpretation) {
                            if (typeof interpretation === 'string') return interpretation;
                            if (interpretation.value) return interpretation.value;
                            if (interpretation.name) return interpretation.name;
                            if (interpretation.content) return interpretation.content;
                            if (interpretation.title) return interpretation.title;
                            if (interpretation.text) return interpretation.text;
                        }
                    } catch (error) {
                        console.log('MCP item interpretation error:', item.item_id, error);
                    }

                    return value || item.item_id;
                };

                const buildRowFromItem = async function (app, item, fieldId, active) {
                    const label = await getItemLabel(app, fieldId, item);

                    return {
                        app_id: normalizeId(app.app_id),
                        item_id: normalizeId(item.item_id),
                        field_id: normalizeId(fieldId),
                        app,
                        item,
                        label,
                        active: typeof active === 'boolean' ? active : true,
                        automationLoading: false
                    };
                };

                const parseMaybeJson = function (value) {
                    if (!value) return value;

                    if (typeof value === 'object') {
                        return value;
                    }

                    if (typeof value === 'string') {
                        try {
                            return JSON.parse(value);
                        } catch (error) {
                            return value;
                        }
                    }

                    return value;
                };

                const extractExternalFunctionData = function (editorData) {
                    const parsedEditorData = parseMaybeJson(editorData);

                    if (parsedEditorData?.externalFunction) {
                        return parsedEditorData.externalFunction;
                    }

                    if (parsedEditorData?.model) {
                        return parsedEditorData;
                    }

                    if (parsedEditorData?.nodes) {
                        return {
                            model: parsedEditorData
                        };
                    }

                    return null;
                };

                const fetchExternalFunctionEditorData = async function (row) {
                    const nodeServicesApiPath = getNodeServicesApiPath();

                    if (!nodeServicesApiPath) {
                        throw new Error('node_services_api_path is not configured');
                    }

                    const appId = normalizeId(row.app_id);
                    const itemId = normalizeId(row.item_id);
                    const fieldId = normalizeId($scope.mcpServer.field_id_with_functions);

                    const url =
                        `${nodeServicesApiPath}/external-function/get` +
                        `?app_id=${encodeURIComponent(appId)}` +
                        `&item_id=${encodeURIComponent(itemId)}` +
                        `&field_id=${encodeURIComponent(fieldId)}`;

                    const request = {
                        method: 'GET',
                        url,
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    };

                    if (gudhub.req && typeof gudhub.req.axiosRequest === 'function') {
                        return gudhub.req.axiosRequest(request);
                    }

                    const response = await fetch(url, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });

                    const result = await response.json();

                    if (!response.ok) {
                        throw new Error(result.message || 'External function loading error');
                    }

                    return result;
                };

                const saveExternalFunctionEditorData = async function (externalFunction) {
                    const nodeServicesApiPath = getNodeServicesApiPath();

                    if (!nodeServicesApiPath) {
                        throw new Error('node_services_api_path is not configured');
                    }

                    const authData = await getAuthData();
                    const data = JSON.parse(angular.toJson(externalFunction));

                    delete data.app;
                    delete data.item;

                    const url = `${nodeServicesApiPath}/external-function/update`;

                    const body = {
                        ...data,
                        token: authData.token,
                        user_id: authData.user_id,
                        auth_key: authData.auth_key
                    };

                    const request = {
                        method: 'POST',
                        url,
                        data: body,
                        headers: {
                            'Content-Type': 'application/json',
                            ...(authData.auth_key && {
                                Authorization: `Bearer ${String(authData.auth_key).replace(/\s/g, '')}`
                            })
                        }
                    };

                    if (gudhub.req && typeof gudhub.req.axiosRequest === 'function') {
                        return gudhub.req.axiosRequest(request);
                    }

                    const response = await fetch(url, {
                        method: 'POST',
                        headers: request.headers,
                        body: JSON.stringify(body)
                    });

                    const result = await response.json();

                    if (!response.ok) {
                        throw new Error(result.message || 'External function update error');
                    }

                    return result;
                };

                $scope.loadRows = async function () {
                    $scope.loading = true;
                    safeApply($scope);

                    try {
                        const fieldId = $scope.mcpServer.field_id_with_functions;
                        const savedItems = getSavedItems();

                        if (!fieldId || !savedItems.length) {
                            $scope.itemRows = [];
                            return;
                        }

                        const rows = [];

                        for (let i = 0; i < savedItems.length; i++) {
                            const savedItem = savedItems[i];

                            if (!savedItem.app_id || !savedItem.item_id) {
                                continue;
                            }

                            const app = await getAppData(savedItem.app_id);
                            const itemsWithField = await getItemsByFieldId(savedItem.app_id, fieldId);

                            const item = itemsWithField.find(function (item) {
                                return normalizeId(item.item_id) === normalizeId(savedItem.item_id);
                            });

                            if (!item) {
                                continue;
                            }

                            const row = await buildRowFromItem(app, item, fieldId, savedItem.active);
                            rows.push(row);
                        }

                        $scope.itemRows = rows;
                    } catch (error) {
                        console.log('MCP external functions load error:', error);
                        $scope.itemRows = [];
                    } finally {
                        $scope.loading = false;
                        safeApply($scope);
                    }
                };

                $scope.$watchGroup([
                    'mcpServer.app_with_functions',
                    'mcpServer.field_id_with_functions'
                ], function (newValues, oldValues) {
                    if (newValues === oldValues) {
                        return;
                    }

                    $scope.loadRows();
                });

                $scope.persistItems = async function () {
                    $scope.mcpServer.items_with_functions = $scope.itemRows.map(function (row) {
                        return {
                            app_id: row.app_id,
                            item_id: row.item_id,
                            active: !!row.active
                        };
                    });

                    try {
                        const updatedMcpServer = await McpServersService.update($scope.mcpServer);
                        Object.assign($scope.mcpServer, updatedMcpServer);
                    } catch (error) {
                        console.log('MCP external functions save error:', error);
                    }

                    safeApply($scope);
                };

                $scope.showAddDialog = function (existingRow) {
                    const tableScope = $scope;

                    GhDialog.show({
                        position: 'center',
                        toolbar: false,
                        template: {
                            toolbar: '',
                            resizable: false,
                            content: `
                                <div class="dialog-share-group add_mcp_item-popup">
                                    <span gh-icon="automation_external_function 0D99FF 65px"></span>

                                    <p class="dialog-share-group__title">
                                        {{translate(existingRow ? 'Edit' : 'Add')}} {{translate('External Function')}}
                                    </p>
                                </div>

                                <div class="dialog-share-group__content">
                                    <div class="dialog-share-group__content__input">
                                        <label>{{translate('External Function')}}</label>

                                        <div ng-show="loadingItems" class="mcp-loading-items">
                                            {{translate('Loading external functions…')}}
                                        </div>

                                        <select
                                            ng-show="!loadingItems"
                                            ng-model="form.selectedItemId"
                                            class="mcp-select"
                                        >
                                            <option value="">{{translate('Select external function…')}}</option>

                                            <option
                                                ng-repeat="item in itemsList track by item.item_id"
                                                value="{{item.item_id}}"
                                            >
                                                {{item.label}}
                                            </option>
                                        </select>

                                        <div
                                            ng-show="!loadingItems && !itemsList.length"
                                            class="mcp-no-items"
                                        >
                                            {{translate('No items found for selected application and field')}}
                                        </div>
                                    </div>

                                    <div ng-show="errMessage" class="error_message">
                                        {{errMessage}}
                                    </div>

                                    <div class="dialog-share-group__content__buttons">
                                        <button
                                            class="dialog-share-group__content__buttons__cancel btn btn-blue-reverse"
                                            ng-click="cancel()"
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            class="dialog-share-group__content__buttons__add btn btn-blue"
                                            ng-click="confirm()"
                                        >
                                            {{translate(existingRow ? 'Save' : 'Add')}}
                                        </button>
                                    </div>
                                </div>
                            `
                        },
                        locals: {
                            mcpServer: $scope.mcpServer,
                            existingRow: existingRow || null
                        },
                        controller: ['$scope', 'mcpServer', 'existingRow', 'localizationService', async function ($scope, mcpServer, existingRow, localizationService) {
                            const dictionary = localizationService.getDictionary('account_settings');
                            $scope.translate = (word) => localizationService.translate(word, dictionary);
                            $scope.mcpServer = mcpServer;
                            $scope.existingRow = existingRow;

                            $scope.itemsList = [];

                            $scope.form = {
                                selectedItemId: existingRow ? normalizeId(existingRow.item_id) : ''
                            };

                            $scope.loadingItems = false;
                            $scope.errMessage = '';

                            const setError = function (message) {
                                $scope.errMessage = message;
                                safeApply($scope);
                            };

                            const clearError = function () {
                                $scope.errMessage = '';
                            };

                            const loadItems = async function () {
                                clearError();

                                const appId = normalizeId(mcpServer.app_with_functions);
                                const fieldId = normalizeId(mcpServer.field_id_with_functions);

                                if (!appId) {
                                    setError('Please select application in MCP Server Info');
                                    return;
                                }

                                if (!fieldId) {
                                    setError('Please select field in MCP Server Info');
                                    return;
                                }

                                $scope.loadingItems = true;
                                safeApply($scope);

                                try {
                                    const app = await getAppData(appId);
                                    const items = await getItemsByFieldId(appId, fieldId);

                                    const mappedItems = [];

                                    for (let i = 0; i < items.length; i++) {
                                        const item = items[i];
                                        const label = await getItemLabel(app, fieldId, item);

                                        mappedItems.push({
                                            app_id: appId,
                                            item_id: normalizeId(item.item_id),
                                            label,
                                            item
                                        });
                                    }

                                    $scope.itemsList = mappedItems;

                                    if (existingRow && existingRow.item_id) {
                                        const selectedItem = mappedItems.find(function (item) {
                                            return normalizeId(item.item_id) === normalizeId(existingRow.item_id);
                                        });

                                        $scope.form.selectedItemId = selectedItem ? normalizeId(selectedItem.item_id) : '';
                                    }
                                } catch (error) {
                                    console.log('MCP items load error:', error);
                                    setError('External functions loading error');
                                } finally {
                                    $scope.loadingItems = false;
                                    safeApply($scope);
                                }
                            };

                            $scope.confirm = async function () {
                                clearError();

                                const selectedAppId = normalizeId(mcpServer.app_with_functions);
                                const selectedFieldId = normalizeId(mcpServer.field_id_with_functions);
                                const selectedItemId = normalizeId($scope.form.selectedItemId);

                                if (!selectedAppId) {
                                    setError('Please select application in MCP Server Info');
                                    return;
                                }

                                if (!selectedFieldId) {
                                    setError('Please select field in MCP Server Info');
                                    return;
                                }

                                if (!selectedItemId) {
                                    setError('Please select external function');
                                    return;
                                }

                                const selectedItem = $scope.itemsList.find(function (item) {
                                    return normalizeId(item.item_id) === selectedItemId;
                                });

                                if (!selectedItem) {
                                    setError('Selected external function was not found');
                                    return;
                                }

                                const alreadyExists = tableScope.itemRows.some(function (row) {
                                    const sameApp = normalizeId(row.app_id) === selectedAppId;
                                    const sameItem = normalizeId(row.item_id) === selectedItemId;

                                    const sameRow = existingRow &&
                                        normalizeId(existingRow.app_id) === normalizeId(row.app_id) &&
                                        normalizeId(existingRow.item_id) === normalizeId(row.item_id);

                                    return sameApp && sameItem && !sameRow;
                                });

                                if (alreadyExists) {
                                    setError('This external function is already added');
                                    return;
                                }

                                try {
                                    const fullApp = await getAppData(selectedAppId);

                                    const newRow = await buildRowFromItem(
                                        fullApp,
                                        selectedItem.item,
                                        selectedFieldId,
                                        existingRow ? existingRow.active : true
                                    );

                                    if (existingRow) {
                                        const index = tableScope.itemRows.findIndex(function (row) {
                                            return normalizeId(row.app_id) === normalizeId(existingRow.app_id) &&
                                                normalizeId(row.item_id) === normalizeId(existingRow.item_id);
                                        });

                                        if (index !== -1) {
                                            tableScope.itemRows[index] = newRow;
                                        }
                                    } else {
                                        tableScope.itemRows.push(newRow);
                                    }

                                    await tableScope.persistItems();

                                    safeApply(tableScope);
                                    $scope.cancel();
                                } catch (error) {
                                    console.log('MCP external function save error:', error);
                                    setError('External function saving error');
                                }
                            };

                            await loadItems();
                        }]
                    });
                };

                $scope.toggleItemActive = async function (row, $event) {
                    if ($event) {
                        $event.stopPropagation();
                    }

                    row.active = !row.active;

                    await $scope.persistItems();
                };

                $scope.showAutomationDialog = async function (row, $event) {
                    if ($event) {
                        $event.stopPropagation();
                    }

                    try {
                        row.automationLoading = true;
                        safeApply($scope);

                        const editorData = await fetchExternalFunctionEditorData(row);
                        const externalFunction = extractExternalFunctionData(editorData);

                        if (!externalFunction || !externalFunction.model || !externalFunction.model.nodes) {
                            console.log('External Function model is missing:', editorData);
                            return;
                        }

                        externalFunction.app_id = normalizeId(row.app_id);
                        externalFunction.item_id = normalizeId(row.item_id);
                        externalFunction.field_id = normalizeId($scope.mcpServer.field_id_with_functions);

                        if (!externalFunction.trigger) {
                            externalFunction.trigger = {
                                debug: false
                            };
                        }

                        GhDialog.show({
                            position: 'bottom',
                            toolbar: true,
                            template: {
                                toolbar: `
                                    <div
                                        ng-click="apply()"
                                        class="gh-automation-apply-button action gh-btn inline btn-blue gh-btn-bg"
                                    >
                                        <p>{{translate('Apply')}}</p>
                                    </div>

                                    <gh-automation-mock
                                        debug-info="debugInfo"
                                        trigger="externalFunction"
                                        init="init"
                                    ></gh-automation-mock>
                                `,
                                resizable: false,
                                content: `
                                    <div class="gh-element-automation">
                                        <gh-automation
                                            debug-info="debugInfo"
                                            app-id="appId"
                                            element-id="externalFunction.field_id"
                                            gh-model="externalFunction.model"
                                            nodes-model="settings"
                                            trigger="externalFunction"
                                            init="init"
                                        ></gh-automation>
                                    </div>
                                `
                            },
                            locals: {
                                row,
                                externalFunction,
                                parentScope: $scope
                            },
                            controller: [
                                '$scope',
                                'row',
                                'externalFunction',
                                'parentScope',
                                function ($scope, row, externalFunction, parentScope) {
                                    $scope.row = row;
                                    $scope.externalFunction = externalFunction;
                                    $scope.appId = externalFunction.app_id;
                                    $scope.init = true;

                                    $scope.debugInfo = {
                                        debuggers: {},
                                        currentNodes: []
                                    };

                                    $scope.settings = {
                                        include_nodes: gudhub.storage.getModulesList('automation')
                                    };

                                    $scope.apply = async function () {
                                        try {
                                            await parentScope.saveExternalFunctionAutomation($scope.externalFunction);
                                            $scope.hide();
                                        } catch (error) {
                                            console.log('External Function automation update error:', error);
                                        }
                                    };
                                }
                            ]
                        });
                    } catch (error) {
                        console.log('External Function automation open error:', error);
                    } finally {
                        row.automationLoading = false;
                        safeApply($scope);
                    }
                };

                $scope.saveExternalFunctionAutomation = async function (externalFunction) {
                    return saveExternalFunctionEditorData(externalFunction);
                };

                $scope.editItem = function (row, $event) {
                    $scope.showAutomationDialog(row, $event);
                };

                $scope.removeItem = async function (row, $event) {
                    if ($event) {
                        $event.stopPropagation();
                    }

                    const index = $scope.itemRows.indexOf(row);

                    if (index !== -1) {
                        $scope.itemRows.splice(index, 1);
                        await $scope.persistItems();
                    }
                };

                await $scope.loadRows();
            }],

            template: `
                <div class="mcp-external-functions-table">
                    <div class="mcp-external-functions-table__header">
                        <p class="mcp-external-functions-table__title">External Functions</p>

                        <button
                            class="btn btn-blue mcp-add-btn"
                            ng-click="showAddDialog()"
                            ng-disabled="!mcpServer.app_with_functions || !mcpServer.field_id_with_functions"
                            ng-class="{ 'mcp-add-btn--disabled': !mcpServer.app_with_functions || !mcpServer.field_id_with_functions }"
                        >
                            + Add
                        </button>
                    </div>

                    <div
                        ng-if="!mcpServer.app_with_functions || !mcpServer.field_id_with_functions"
                        class="mcp-external-functions-table__hint"
                    >
                        Select application and field in MCP Server Info before adding external functions.
                    </div>

                    <div class="listing_table">
                        <div class="listing_table_head_wrapper">
                            <div class="listing_table_column bottom_line w-35">
                                <div class="tab">Application</div>
                            </div>

                            <div class="listing_table_column w-30">
                                <div class="tab">External Function</div>
                            </div>

                            <div class="listing_table_column w-20">
                                <div class="tab">Active</div>
                            </div>

                            <div class="listing_table_column w-15"></div>
                        </div>

                        <div class="listing_table_body_wrapper">
                            <div
                                ng-if="loading"
                                class="listing_table_loader"
                            >
                                <gh-loader type="dual-ring" color="blue"></gh-loader>
                            </div>

                            <div
                                ng-if="!loading && !itemRows.length"
                                class="listing_table_nodata small"
                            >
                                <p>{{translate('No External Functions')}}</p>
                            </div>

                            <div
                                class="listing_table_row"
                                ng-if="!loading"
                                ng-repeat="row in itemRows track by row.app_id + '-' + row.item_id"
                            >
                                <div class="listing_table_column w-35">
                                    <span
                                        class="app_icon"
                                        gh-icon="{{row.app.icon.icon_id}} {{row.app.icon.icon_color}} 34px normal {{row.app.icon.gradient_up}} {{row.app.icon.gradient_down}}"
                                    ></span>

                                    <div class="name">
                                        {{row.app.app_name}}
                                    </div>
                                </div>

                                <div class="listing_table_column w-30">
                                    <div class="name">
                                        {{row.label}}
                                    </div>
                                </div>

                                <div class="listing_table_column w-20">
                                    <label
                                        class="mcp-switch"
                                        ng-click="toggleItemActive(row, $event)"
                                    >
                                        <input
                                            type="checkbox"
                                            ng-model="row.active"
                                            ng-click="$event.stopPropagation()"
                                        >

                                        <span class="mcp-switch__slider"></span>
                                    </label>
                                </div>

                                <div class="listing_table_column w-15 row-actions">
                                    <span
                                        ng-if="!row.automationLoading"
                                        class="edit_icon"
                                        gh-icon="pencil 0d99ff 20px"
                                        ng-click="editItem(row, $event)"
                                        title="Edit automation"
                                    ></span>

                                    <gh-loader
                                        ng-if="row.automationLoading"
                                        type="dual-ring"
                                        color="blue"
                                    ></gh-loader>

                                    <span
                                        class="delete_icon"
                                        gh-icon="rubbish 0d99ff 20px"
                                        ng-click="removeItem(row, $event)"
                                        title="Delete"
                                    ></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `
        };
    }]);